// extracted by css-extract-rspack-plugin
export default {"formBox":"formBox-OI5gfe","formWrap":"formWrap-fa5aR8","userFormSaveBtn":"userFormSaveBtn-Ziq5up"};